import {ChecklistProvider} from '../../context/checklist/ChecklistContextProvider';
import OperationsContextProvider from '../../context/OperationsContextProvider';

import MainPage from './components/MainPage';

function Checklist() {
  return (
    <OperationsContextProvider>
      <ChecklistProvider>
        <MainPage />
      </ChecklistProvider>
    </OperationsContextProvider>
  );
}

export default Checklist;
